import { createContext } from 'react';

const ManagementContext = createContext({});

export default ManagementContext;
